import calculateRatesFormModel from "./form-model";

const {
    formFields: {
        weight,
        destinationZip,
        originatingZip,
        dropoffPickup
    }
} = calculateRatesFormModel;

const initialValues = {
    [weight.name]: "",
    [destinationZip.name]: "",
    [originatingZip.name]: "",
    [dropoffPickup.name]: "",
    showRate: "",
    rates: []
}

export default initialValues